@if (hasActiveSubscription) {
  <div class="subscription-card">
    <div class="subscription-header">
      <mat-icon class="subscription-icon">card_membership</mat-icon>
      <h4 class="subscription-title">{{ 'My subscription' | translate }}</h4>
    </div>

    <div class="subscription-body">
      <div class="subscription-row">
        <span class="subscription-label">{{ 'Subscription package' | translate }}</span>
        <span class="subscription-value">{{ subscription_package }}</span>
      </div>

      @if (subscription_expiration_date) {
        <div class="subscription-row">
          <span class="subscription-label">{{ 'Subscription expiration date' | translate }}</span>
          <span class="subscription-value">{{ subscription_expiration_date }}</span>
        </div>
      } @else {
        <p class="subscription-note">
          {{ 'Contact your administrator to review your subscription' | translate }}
        </p>
      }

      <!-- Facility access row -->
      @if (facilitiesEnabled && showFacilityRow) {
        <div class="subscription-row subscription-row--facilities">
          <span class="subscription-label">{{ 'Access' | translate }}</span>
          <div class="sub-fac-chips">
            @if (!facilityIds?.length) {
              <span class="sub-fac-chip sub-fac-chip--all">{{ 'All facilities' | translate }}</span>
            }
            @for (fac of accessChips; track fac.id) {
              <span class="sub-fac-chip" [style.--fac-color]="fac.color">
                <span class="sub-fac-chip__dot"></span>
                {{ fac.name }}
                @if (fac.limit) {
                  <span class="sub-fac-chip__limit">
                    · {{
                      ('member_cap_' + fac.limit.interval)
                        | translate: { n: fac.limit.max_reservations }
                    }}
                  </span>
                }
              </span>
            }
          </div>
        </div>
      }

      @if (daysLeft < 10 && daysLeft >= 0) {
        <div class="progress-section">
          <div class="progress-bar-track">
            <div
              class="progress-bar-fill"
              [class.progress-bar-fill--warning]="daysLeft > 5"
              [class.progress-bar-fill--danger]="daysLeft <= 5"
              [style.width.%]="100 - 10 * daysLeft"
            ></div>
          </div>
          <span class="progress-label">{{ daysLeft }} {{ 'days left' | translate }}</span>
        </div>
      }
    </div>
  </div>
}
